/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useRoute } from '@jira/navigation-apps__routing-hooks/src/useRoute.tsx';
import type { RouteName } from '@jira/platform__routing-route-name-types/src/RouteName.tsx';

const GENERAL_CONNECT_ROUTES = new Set<RouteName>([
	'connect-general',
	'connect-general-invalid',
	'legacy-connect-general',
	'connect-general-service-desk-project',
]);

const UNCERTAIN_APPS_SECTION_ROUTES = GENERAL_CONNECT_ROUTES;

const CERTAIN_APPS_SECTION_ROUTES = new Set<RouteName>(['forge-spa-global', 'marketplace-index']);

export const APPS_SECTION_ROUTES: Set<RouteName> = new Set<RouteName>([
	...UNCERTAIN_APPS_SECTION_ROUTES,
	...CERTAIN_APPS_SECTION_ROUTES,
]);

/**
 * @returns true when the current route is a general Connect route.
 */
export function useIsGeneralConnectRoute(): boolean {
	const route = useRoute();

	return GENERAL_CONNECT_ROUTES.has(route.name);
}
